import { FetchState } from '@lib/mobx/fetch-state';

export class CMSFetchState<TData> extends FetchState<TData> {}

FetchState.configureDataSource<object>({
  id: 'cms-fetch-state',
  is: () => false,
  isSuccess: () => false,
  data: () => null,
  error: () => null,
});
